import r from "js-cookie";
class h {
  /**
   * Configures the CookieStorage
   *
   * @param {object} data options.
   * @param {string} data.domain Cookies domain (mandatory).
   * @param {string} data.path Cookies path (default: '/')
   * @param {integer} data.expires Cookie expiration (in days, default: 365)
   * @param {boolean} data.secure Cookie secure flag (default: true)
   * @param {string} data.sameSite Cookie request behaviour (default: null)
   * @param {boolean} data.deviceTracking Device tracking enabled in cognito (default: true)
   */
  constructor({
    domain: e,
    path: t = "/",
    expires: s = 30,
    // days
    secure: o = !0,
    sameSite: i = "strict",
    deviceTracking: a = !0
  } = {}) {
    if (e)
      this.domain = e;
    else
      throw new Error("The domain of cookieStorage can not be undefined.");
    if (this.path = t, this.expires = s, this.secure = o, i != null) {
      if (!["strict", "lax", "none"].includes(i))
        throw new Error(
          'The sameSite value of cookieStorage must be "lax", "strict" or "none".'
        );
      if (i === "none" && !this.secure)
        throw new Error(
          "sameSite = None requires the Secure attribute in latest browser versions."
        );
    }
    this.sameSite = i, this.deviceTracking = a;
  }
  /**
   * This is used to set a specific item in storage
   * @param {string} key - the key for the item
   * @param {object} value - the value
   * @returns {void}
   */
  async setItem(e, t) {
    switch (this.getStorageMechanism(e)) {
      case "cookie":
        r.set(this.trimKey(e), t, this.getCookieOptions());
        break;
      case "localStorage":
      default:
        localStorage.setItem(e, t);
    }
  }
  /**
   * This is used to get a specific key from storage
   * @param {string} key - the key for the item
   * @returns {string} the data item
   */
  async getItem(e) {
    switch (this.getStorageMechanism(e)) {
      case "cookie":
        return r.get(this.trimKey(e));
      case "localStorage":
      default:
        return localStorage.getItem(e);
    }
  }
  /**
   * This is used to remove an item from storage
   * @param {string} key - the key being set
   * @returns {string} value - value that was deleted
   */
  async removeItem(e) {
    switch (this.getStorageMechanism(e)) {
      case "cookie":
        return r.remove(this.trimKey(e), this.getCookieOptions());
      case "localStorage":
      default:
        return localStorage.removeItem(e);
    }
  }
  getCookieOptions() {
    const e = {
      path: this.path,
      expires: this.expires,
      domain: this.domain,
      secure: this.secure
    };
    return this.sameSite && (e.sameSite = this.sameSite), e;
  }
  /**
   * This is used to clear the storage
   * @returns {void}
   */
  async clear() {
    const e = r.get();
    for (let t = 0; t < e.length; t += 1)
      r.remove(e[t]);
    localStorage.clear();
  }
  trimKey(e) {
    const t = e.lastIndexOf(".");
    let s = "";
    t > 0 && (s = this.hashCode(e.slice(0, t + 1)));
    const o = e.slice(t + 1);
    return s + o;
  }
  getStorageMechanism(e) {
    const t = e.lastIndexOf(".");
    let s = e;
    switch (t > 0 && (s = e.slice(t + 1)), s) {
      case "refreshToken":
      case "accessToken":
      case "idToken":
      case "signInDetails":
      case "LastAuthUser":
        return "cookie";
      default:
        return "localStorage";
    }
  }
  hashCode(e) {
    let t = 0;
    if (e.length === 0)
      return t;
    for (let s = 0; s < e.length; s += 1) {
      const o = e.charCodeAt(s);
      t = (t << 5) - t + o, t &= t;
    }
    return t;
  }
}
export {
  h as C
};
